import { render, staticRenderFns } from "./SysRole.vue?vue&type=template&id=724a3f73&"
import script from "./SysRole.vue?vue&type=script&lang=js&"
export * from "./SysRole.vue?vue&type=script&lang=js&"
import style0 from "./SysRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports